// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../imageLarge.fragment.generated';
export const CardCarouselCardFragmentDoc = gql`
    fragment cardCarouselCard on CardCarouselCard {
  backgroundColor
  image {
    ...imageLarge
  }
  title
  description
}
    ${ImageLargeFragmentDoc}`;